import { createAsyncThunk } from '@reduxjs/toolkit';

export const setSearchValue = createAsyncThunk(
  'setSearchValue',
  async (
    data: { searchValue: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return { searchValue: data.searchValue };
  }
);

export default setSearchValue;
